import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
// @ts-expect-error ts-migrate(2307) FIXME: Cannot find module '../../../Mobile/MobileBookingW... Remove this comment to see the full error message
import s from '../../../Mobile/MobileBookingWidgetSecondForm.css';
import {
  ADDRESS_FIELD_NAME,
  CITY_FIELD_NAME,
  isFieldRequired,
  STATE_CODE_FIELD_NAME,
  ZIP_CODE_FIELD_NAME,
  ADDRESS_SECONDARY_FIELD_NAME,
  getMobileSecondFormRequiredFields,
} from '../../../util/validators';
import {
  BOOKING_WIDGET_TOUCH_ADDRESS,
  BOOKING_WIDGET_TOUCH_ADDRESS_SECONDARY,
  BOOKING_WIDGET_TOUCH_CITY,
  BOOKING_WIDGET_TOUCH_STATE,
  BOOKING_WIDGET_TOUCH_ZIP_CODE,
} from '../../../../../core/analytics/events';
import {
  emptyInteractions,
  getFieldObject,
} from '../../../../../core/util/rcForm/rcFormToReduxForm';

import TextInput from '../../../../Form/TextInput';
import StateCodeSelectInput from '../../../../Form/StateCodeSelectInput';

const Root = styled.div.withConfig({ componentId: 'sc-r4ln35-0' })`
  margin-top: 10px;
`;

type Props = {
  form: any;
  initialValues: any;
  location: any;
  setZIndexGivenError: (...args: any[]) => any;
  submitted: boolean;
  validateField: (...args: any[]) => any;
  placeholder?: string;
};

const MobileSeparateFields = (props: Props) => {
  const {
    form,
    initialValues,
    location,
    setZIndexGivenError,
    submitted,
    validateField,
    placeholder,
  } = props;

  const { t } = useTranslation(['common', 'bookingWidget']);

  const address = getFieldObject(ADDRESS_FIELD_NAME, props, emptyInteractions);
  const addressSecondary = getFieldObject(ADDRESS_SECONDARY_FIELD_NAME, props, emptyInteractions);
  const city = getFieldObject(CITY_FIELD_NAME, props, emptyInteractions);
  const stateCode = getFieldObject(STATE_CODE_FIELD_NAME, props, emptyInteractions);
  const zipCode = getFieldObject(ZIP_CODE_FIELD_NAME, props, emptyInteractions);

  return (
    <Root>
      <div className={s.homeAddress} data-testid="mobileWidgetAddressFields">
        <div className={s.row} style={setZIndexGivenError(address)}>
          <div className={s.address}>
            <TextInput
              errorInline
              field={address}
              funPlaceholder
              id={ADDRESS_FIELD_NAME}
              inputProps={form.getFieldProps(ADDRESS_FIELD_NAME, {
                rules: [
                  {
                    required: getMobileSecondFormRequiredFields(location, form).includes(
                      ADDRESS_FIELD_NAME
                    ),
                    message: t('common:required'),
                  },
                ],
                initialValue: initialValues[ADDRESS_FIELD_NAME],
              })}
              placeholder={placeholder}
              placeholderContainerName={s.inputPlaceholder}
              s={s}
              showErrors={false}
              submitted={submitted}
              trackEvent={BOOKING_WIDGET_TOUCH_ADDRESS}
            />
          </div>
        </div>

        <div className={s.row} style={setZIndexGivenError(address)}>
          <div className={s.address}>
            <TextInput
              errorInline
              field={addressSecondary}
              funPlaceholder
              id={ADDRESS_SECONDARY_FIELD_NAME}
              inputProps={form.getFieldProps(ADDRESS_SECONDARY_FIELD_NAME, {
                rules: [
                  {
                    required: isFieldRequired(ADDRESS_SECONDARY_FIELD_NAME, location, form),
                    message: t('common:required'),
                  },
                ],
                initialValue: initialValues[ADDRESS_SECONDARY_FIELD_NAME],
              })}
              onBlur={validateField}
              placeholder={t(
                'bookingWidget:userProfileAndPatientInfo.homeAddressSeparateFields.aptSuiteEtcOptional'
              )}
              placeholderContainerName={s.inputPlaceholder}
              s={s}
              showErrors={false}
              submitted={submitted}
              trackEvent={BOOKING_WIDGET_TOUCH_ADDRESS_SECONDARY}
            />
          </div>
        </div>

        <div className={s.row} style={setZIndexGivenError(city)}>
          <div className={s.cityParts}>
            <div className={s.city}>
              <TextInput
                errorInline
                field={city}
                funPlaceholder
                id={CITY_FIELD_NAME}
                inputProps={form.getFieldProps(CITY_FIELD_NAME, {
                  rules: [
                    {
                      required: getMobileSecondFormRequiredFields(location, form).includes(
                        CITY_FIELD_NAME
                      ),
                      message: t('common:required'),
                    },
                  ],
                  initialValue: initialValues[CITY_FIELD_NAME],
                })}
                placeholder={t(
                  'bookingWidget:userProfileAndPatientInfo.homeAddressSeparateFields.city'
                )}
                placeholderContainerName={s.inputPlaceholder}
                s={s}
                showErrors={false}
                submitted={submitted}
                trackEvent={BOOKING_WIDGET_TOUCH_CITY}
              />
            </div>

            <div className={s.stateCode}>
              <StateCodeSelectInput
                defaultValue={t(
                  'bookingWidget:userProfileAndPatientInfo.homeAddressSeparateFields.state'
                )}
                errorInline
                field={stateCode}
                funPlaceholder
                id={STATE_CODE_FIELD_NAME}
                inputProps={form.getFieldProps(STATE_CODE_FIELD_NAME, {
                  rules: [
                    {
                      required: getMobileSecondFormRequiredFields(location, form).includes(
                        STATE_CODE_FIELD_NAME
                      ),
                      message: t('common:required'),
                    },
                  ],
                  initialValue: initialValues[STATE_CODE_FIELD_NAME],
                })}
                onBlur={validateField}
                placeholder={t(
                  'bookingWidget:userProfileAndPatientInfo.homeAddressSeparateFields.state'
                )}
                s={s}
                showErrors={false}
                submitted={submitted}
                trackEvent={BOOKING_WIDGET_TOUCH_STATE}
              />
            </div>

            <div className={s.zipCode}>
              <TextInput
                errorInline
                field={zipCode}
                funPlaceholder
                id={ZIP_CODE_FIELD_NAME}
                inputProps={form.getFieldProps(ZIP_CODE_FIELD_NAME, {
                  rules: [
                    {
                      required: getMobileSecondFormRequiredFields(location, form).includes(
                        ZIP_CODE_FIELD_NAME
                      ),
                      message: t('common:required'),
                    },
                  ],
                  initialValue: initialValues[ZIP_CODE_FIELD_NAME],
                  pattern: '[0-9]*',
                  inputMode: 'numeric',
                })}
                placeholder={t(
                  'bookingWidget:userProfileAndPatientInfo.homeAddressSeparateFields.zipCode'
                )}
                placeholderContainerName={s.inputPlaceholder}
                s={s}
                showErrors={false}
                submitted={submitted}
                trackEvent={BOOKING_WIDGET_TOUCH_ZIP_CODE}
              />
            </div>
          </div>
        </div>
      </div>
    </Root>
  );
};

export default MobileSeparateFields;
